import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Box, Flex, Text, Center, Input, Button, useToast, Image, 
    Heading,
    VStack, } from "@chakra-ui/react";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import c from "../../constant"
import { gql, useMutation } from '@apollo/client';
import LOGO from "../../assets/images/Google_Authenticator.png"
import useStore from '../../store';

const GENERATE_2FA_SECRET = gql`
  mutation {
    generateTwoFactorSecret
  }
`;

const ENABLE_2FA = gql`
  mutation Enable2FA($code: String!) {
    enableTwoFactor(code: $code)
  }
`;

function ChangePassword() {
    const { t } = useTranslation();
    const { currentUser } = useStore((state) => state.currentUser);
    const toast = useToast();
    const [qrCode, setQrCode] = useState(null);
    const [code, setCode] = useState('');
    const [enabled, setEnabled] = useState(false);
    const [generateSecret, { loading: loadingQR }] = useMutation(GENERATE_2FA_SECRET, {
        onCompleted: (data) => setQrCode(data.generateTwoFactorSecret),
        onError: () => toast({ status: 'error', title: 'Failed to generate QR code' }),
    });

    const [enable2FA, { loading: enabling }] = useMutation(ENABLE_2FA, {
        variables: { code },
        onCompleted: (data) => {
            if (data.enableTwoFactor) {
                setEnabled(true);
                toast({ status: 'success', title: '2FA enabled successfully' });
            } else {
                toast({ status: 'error', title: 'Invalid code' });
            }
        },
        onError: () => toast({ status: 'error', title: 'Error enabling 2FA' }),
    });

    return (
        <>
            <Container maxW="container.xl" mt="16px" mb="16px">
                <BreadcrumbComponent
                    list={[
                        {
                            name: t("Account"),
                            path: "/account",
                        },
                        {
                            name: t("2FA"),
                            path: "#",
                        }
                    ]}
                />
                <Center mt="5">
                   
                    <Box
                        w="100%"
                        bg="white"
                        borderRadius={c.borderRadius}
                        border="1px solid #dbdbdb"
                        boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
                        pb="32px"
                    >
                        <Flex bg="#FAFAFA" p="16px" pt="8px" pb="8px" mb="16px" justifyContent="space-between" borderBottom="1px solid #dbdbdb">
                            <Text
                                fontSize="x-large"
                                fontWeight="bold"
                            >
                                {t("2FA")}
                            </Text>
                        </Flex>
                        <center>
                            <Image src={LOGO} w="100px"/>
                        </center>
                        {currentUser?.username && <center><Box maxW="md" mx="auto" m="6" p={6} borderWidth={1} borderRadius={c.borderRadius} boxShadow="md" mt="0">
                            {(currentUser?.isTwoFactorEnabled) ? (
                                <Text fontSize="sm" color="green.500">
                                    ✅ Two-Factor Authentication is now enabled.
                                </Text>
                            ) :
                                <Box>
                                <VStack spacing={6}>
                                    <Heading size="md">Two-Factor Authentication</Heading>

                                    {!qrCode ? (
                                        <Button onClick={() => generateSecret()} colorScheme="blue" isLoading={loadingQR}>
                                            Generate QR Code
                                        </Button>
                                    ) : (
                                        <>
                                           {!enabled&& <>
                                            <center>
                                                <Text fontSize="sm" mb={2}>
                                                    Scan this QR code with Google Authenticator:
                                                </Text>
                                                <Image src={qrCode} alt="QR Code" borderRadius="md" />
                                                <Text>Please download <b>Google Authenticator</b> from App Store/Play Store.</Text>
                                            </center>

                                            <Box w="100%">
                                                <Text fontSize="sm" mb={1}>
                                                    Enter the 6-digit code from the app:
                                                </Text>
                                                <Input
                                                    autoFocus={true}
                                                    type="text"
                                                    maxLength={6}
                                                    value={code}
                                                    onChange={(e) => setCode(e.target.value)}
                                                    placeholder=""
                                                    isDisabled={enabled}
                                                />
                                            </Box>

                                            <Button
                                                colorScheme="green"
                                                onClick={() => enable2FA()}
                                                isDisabled={enabled || code.length !== 6}
                                                isLoading={enabling}
                                            >
                                                Verify Code & Enable
                                            </Button>
                                            </>}
                                            {enabled && (
                                                <Text fontSize="sm" color="green.500">
                                                    ✅ Two-Factor Authentication is now enabled.
                                                </Text>
                                            )}
                                        </>
                                    )}
                                </VStack>
                                </Box>}
                        </Box></center>}
                    </Box>
                </Center>
            </Container>
        </>
    );
}

export default ChangePassword;
